import type { BoardCard, User } from '../types';

export function boardViewIsAssignee(card: Pick<BoardCard, 'user_id'>, userId?: number): boolean {
  return Boolean(userId && card.user_id === userId);
}

// Stable creator IDs take precedence over labels, including after a rename.
// Only historical/null-ID cards use label matching for compatibility (all
// directed sources, including intake and board_dependency). Duplicate legacy
// names remain ambiguous; this is display logic, not authorization.
export function boardSeenVisible(card: Pick<BoardCard, 'source' | 'created_by_label' | 'created_by_user_id' | 'user_id'>, me: Pick<User, 'id' | 'name' | 'role'> | null): boolean {
  if (!me) return false;
  if (me.role === 'admin') return true;
  if (card.created_by_user_id != null) return card.created_by_user_id === me.id;
  return (!card.source && card.user_id === me.id) ||
    (Boolean(card.created_by_label.trim()) && card.created_by_label.trim() === me.name.trim());
}

export function boardSeenDate(value: string, language: string, now = Date.now()): string {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  const day = (d: Date) => d.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
  const today = day(date) === day(new Date(now));
  const formatter = new Intl.DateTimeFormat(language, {
    timeZone: 'Asia/Kolkata',
    ...(today ? { hour: '2-digit', minute: '2-digit', hour12: true } : { day: 'numeric', month: 'short' })
  });
  if (today) return formatter.format(date);
  const parts = formatter.formatToParts(date);
  return `${parts.find((part) => part.type === 'day')?.value} ${parts.find((part) => part.type === 'month')?.value}`;
}
